export const timestampToDatetimeString = (timestamp) => {
  const date = new Date(timestamp * 1000);
  const options = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };
  return date.toLocaleDateString() + " " + date.toLocaleTimeString([], options);
};
